import styled from 'styled-components'

export const ChipBottomSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 45rem;
  padding: 0 1.25rem 1.5rem;

  @media (max-width: 48rem) {
    max-height: 70dvh;
  }
`

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  gap: 0.5rem;
`

export const SelectedFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  touch-action: pan-x;
  -webkit-overflow-scrolling: touch;
  gap: 0.5rem;

  && > * {
    flex: 0 0 auto;
    width: auto !important;
    max-width: max-content;
  }
`

export const FilterSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  gap: 1.5rem;
`

export const FilterActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 0.75rem;
  margin-top: 1.5rem;
`

export const FilterSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const StatusOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
`
